<template>
  <div>
    <div class="container-fluid">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import HeaderTitle from './Header/';
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    HeaderTitle
  },
  methods: {
    ...mapActions({
      removeCurrentOrder: 'removeCurrentOrder'
    })
  },
  created(){
    if (localStorage.getItem('user_language')) {
      this.$root.locale = localStorage.getItem('user_language');
    } else {
      this.$http.get('/api/user').then(response => {
        localStorage.setItem('user_language', response.data.country);
        this.$root.locale = response.data.country
      })
    }
  },
  mounted () {
    this.removeCurrentOrder();
    this.$emit('input', null);
  }
};
</script>

<style>
  .container-flex{
    width: 98.44%;
  }

  .sidebar-wrapper{
    border-right:1px solid #eee;
  }
</style>




// WEBPACK FOOTER //
// resources/assets/js/components/Index.vue